import { StartClient } from '@tanstack/react-start/client';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (import.meta.env.PROD && sentryDsn) {
  void import('./lib/sentry-init')
    .then(({ initBrowserSentry }) => {
      initBrowserSentry(sentryDsn);
    })
    .catch((error) => {
      if (import.meta.env.DEV) {
        console.warn('Sentry failed to initialise', error);
      }
    });
}

hydrateRoot(
  document,
  <StrictMode>
    <StartClient />
  </StrictMode>
);
